// extracted by mini-css-extract-plugin
export default {"h1":"H1-module__h1___AiAYS","bold":"H1-module__bold___g1CW6","muted":"H1-module__muted___hMjhm","inline":"H1-module__inline___Z0HhZ"};